import { createApp } from 'vue';
import { createPinia } from 'pinia';

import App from './App.vue';
import router from './router';

import Toast from 'vue-toastification';
import ClickOutside from '@/modules/shared/helpers/ClickOutsideDirective';
import 'vue-toastification/dist/index.css';
import './assets/main.css';

const app = createApp(App);

app.directive('click-outside', ClickOutside);

app.use(Toast, {
    transition: 'Vue-Toastification__fade',
    maxToasts: 3,
    newestOnTop: true,
    position: 'bottom-right',
    timeout: 5000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.45,
    showCloseButtonOnHover: false,
    hideProgressBar: true,
    closeButton: 'button',
    icon: true,
    rtl: false
});

app.use(createPinia());
app.use(router);

app.mount('#app');
